import React from "react";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Stack, Typography } from "@mui/material";

import { TeamPermissionsTableRow } from "@app/analytics/account/types";
import OpenMenuButton from "@app/analytics/components/OpenMenuButton";
import TableCell from "@app/analytics/components/Table/TableCell";
import { EnterpriseWorkspaceTeam } from "@app/common/workspaces/types";
import useAnchorElement from "@app/utils/hooks/useAnchorElement";

import MenuItem from "../../components/MenuItem";

const TeamNameCell = ({
  onTeamSelect,
  team,
  teams,
}: {
  onTeamSelect: (name: string) => void;
  team: TeamPermissionsTableRow;
  teams: EnterpriseWorkspaceTeam[];
}) => {
  const anchorElement = useAnchorElement();

  const handleTeamSelect = (teamId: string) => () => {
    onTeamSelect(teamId);
    anchorElement.onClose();
  };

  return (
    <TableCell sx={{ minWidth: "148px" }}>
      <Stack>
        {team.name ? (
          <Typography
            variant="bodySecondaryReg"
            sx={{
              maxWidth: "300px",
              color: "shades.neutral.500",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {team.name}
          </Typography>
        ) : (
          <Stack direction="row" alignItems="center">
            <OpenMenuButton
              {...anchorElement}
              buttonSx={{ ml: -1 }}
              component={
                <>
                  <Typography
                    variant="bodySecondaryReg"
                    sx={{
                      color: "shades.neutral.500",
                      mr: 1,
                      fontFamily: (theme) => theme.typography.fontFamily,
                    }}
                  >
                    Select Team
                  </Typography>
                  <ExpandMoreIcon
                    sx={{
                      width: "20px",
                      height: "20px",
                      color: anchorElement.open
                        ? "shades.primary.500"
                        : "shades.neutral.500",
                    }}
                  />
                </>
              }
              id={`user-team-select-${team}`}
              menuItems={teams.map((t) => (
                <MenuItem key={t.id} onClick={handleTeamSelect(t.id)}>
                  {t.name}
                </MenuItem>
              ))}
            />
          </Stack>
        )}
      </Stack>
    </TableCell>
  );
};

export default TeamNameCell;
